import React from 'react'

import { IRadioButtonProps } from './types'

export const Radio = React.forwardRef<HTMLInputElement, IRadioButtonProps>(
  ({ label, className, ...rest }, ref) => {
    return (
      <label>
        <input ref={ref} {...rest} type="radio" />
        {!!label && <span className="radio-label">{label}</span>}
      </label>
    )
  },
)

Radio.displayName = 'Radio'
